import { useState } from 'react';
import { Group, Input, NumberField } from 'react-aria-components';

import Button from '@/design_system/Button';
import IconAdd from '@/icons/Add.svg';
import IconSubtract from '@/icons/Subtract.svg';
import { createBEMClasses } from '@/utils/classname';

import './InputQuantity.css';

export type InputQuantityProps = {
  onChange: (value: number) => void;
  value: number;
  ariaLabel: string;
  className?: string;
  disabled?: boolean;
  variant?: 'default' | 'expanded';
  size?: 'small' | 'large';
  edited?: boolean;
  minValue?: number;
  isInvalid?: boolean;
};

const { block, element } = createBEMClasses('input-quantity-ds');

export const InputQuantity = ({
  onChange,
  value = 0,
  ariaLabel,
  className,
  disabled = false,
  variant = 'default',
  size = 'small',
  minValue = 0,
  isInvalid,
  edited = false,
}: InputQuantityProps) => {
  const [inputSize, setInputSize] = useState(2);

  return (
    <NumberField
      isDisabled={disabled}
      aria-label={ariaLabel}
      minValue={minValue}
      onChange={(value) => {
        if (isNaN(value)) {
          setInputSize(2);
          onChange(0);

          return;
        }

        const roundedValue = Math.round(value);

        setInputSize(roundedValue.toString().length + 1);
        onChange(roundedValue);
      }}
      onInput={(input) => {
        setInputSize(input.currentTarget.value.length + 1);
      }}
      value={value}
    >
      <Group
        className={block(
          {
            variant,
            size,
            edited,
            invalid: isInvalid,
          },
          className
        )}
      >
        <Button className={element('decrement')} slot="decrement" variant="secondary">
          <IconSubtract />
        </Button>
        <Input size={inputSize} />
        <Button className={element('increment')} slot="increment" variant="secondary">
          <IconAdd />
        </Button>
      </Group>
    </NumberField>
  );
};
